// extracted by mini-css-extract-plugin
module.exports = {"stylizedAlert":"stylizedAlert_4B3y4","stylizedDescription":"stylizedDescription_3qmf-"};